import React from "react";
import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { hasPermission, selectOrganization } from "go-security/services/organizations/selectors";
import { selectIsAdmin } from "go-security/services/users/selectors";

const SubmenuAdvancedNavigation = (): JSX.Element => {
	const { t } = useTranslation();
	const organization = useSelector(selectOrganization);
	const isAdmin = useSelector(selectIsAdmin);
	const isSupportRole = useSelector(hasPermission(["SUPPORT"]));

	return (
		<div className="content-navigation">
			<Nav>
				<Nav.Item>
					<Nav.Link as={NavLink} to={`/${organization.id}/settings/advanced/copy-place`}>
						{t("modules.setting.action.copy_data_from_other_location.title")}
					</Nav.Link>
				</Nav.Item>
				{(isSupportRole || isAdmin) && (
					<Nav.Item>
						<Nav.Link as={NavLink} to={`/${organization.id}/settings/advanced/others`}>
							{t("modules.setting.field.others.title")}
						</Nav.Link>
					</Nav.Item>
				)}
				{/*<Nav.Item>*/}
				{/*    <Nav.Link as={NavLink} to={`/${organization.id}/settings/advanced/copy-test-place`}>*/}
				{/*        {t("modules.setting.action.copy_data_from_other_test_location.title")}*/}
				{/*    </Nav.Link>*/}
				{/*</Nav.Item>*/}
			</Nav>
		</div>
	);
};

export default SubmenuAdvancedNavigation;
